goog.module('yext.entity.fields.SearchableOption');
goog.module.declareLegacyNamespace();

const Autocomplete = goog.require('yext.autocomplete.Autocomplete');
const helpers = goog.require('yext.location.helpers');

/**
 * Option field with static values that uses autocomplete
 * TODO(mattjs) Indeterminate support
 * @param {!jQuery} $ctx The field context
 * @constructor
 */
const SearchableOption = function($ctx) {
  this.$ctx = $ctx;
  this.$field = $ctx.find('.js-searchable-option-field').addBack().filter('.js-searchable-option-field');
  this.$edit = this.$field.find('.js-searchable-option-field-edit');
  this.$searcher = this.$field.find('.js-searchable-option-field-searcher');
  this.$input = this.$field.find('.js-searchable-option-field-searcher-input');
  this.$selection = this.$field.find('.js-searchable-option-field-selection');

  this.options = this.parseOptions();
  this.value = this.$edit.data('value');
  this.indeterminate = this.$edit.data('indeterminate');

  this.storeValue();
  this.bindAutocomplete();
  this.bindClearSelection();
};

/**
 * Parse the options from the DOM, translating keys
 */
SearchableOption.prototype.parseOptions = function() {
  return this.$edit.data('options').map(function(option) {
    return {
      value: option['value'],
      label: option['label'],
    };
  });
};

/**
 * Bind the autocomplete functionality
 */
SearchableOption.prototype.bindAutocomplete = function() {
  var self = this;

  var $results = this.$field.find('.js-search-results');
  var $target = this.$field.find('.js-search-results-target');

  this.autocomplete = new Autocomplete({
    $input: this.$input,
    $target: $target,
    $activeRegion: this.$searcher,
    source: function(request, response) {
      self.handleSearch(request, response);
    },
  });

  $(this.autocomplete).on('select', function(e, selection) {
    self.valueSelected(selection);
  });

  $(this.autocomplete).on('hide', function() {
    $results.hide();
  });

  $(this.autocomplete).on('show', function() {
    if (!$results.is(':visible')) {
      $results.show();
      $results.position({
        'my': 'left top',
        'at': 'left bottom',
        'of': this.$input,
      });
    }
  });
};

/**
 * Bind the clear field icon
 */
SearchableOption.prototype.bindClearSelection = function() {
  var self = this;
  this.$edit.find('.js-clear-selection').click(function() {
    self.clear();
    self.focus();
    self.onUpdate();
  });
};

/**
 * Filter the options list based upon the request
 *
 * @param {string} request The search term
 * @param {function()} response A callback that is made once the search is complete
 */
SearchableOption.prototype.handleSearch = function(request, response) {
  // Short circuit with empty search
  if (request === '') {
    response(this.options);
    return;
  }
  var filteredOptions = this.options.filter(function(option) {
    var re = Autocomplete.buildRegex(request);
    return re.test(option.label);
  });
  response(filteredOptions);
};

/**
 * Set the value of the field after it has been selected
 * @param {!Object} selection Option being selected
 */
SearchableOption.prototype.valueSelected = function(selection) {
  this.value = selection.value;
  this.onUpdate();
};

/**
 * Called when the field is updated to render the new state and emit an update
 */
SearchableOption.prototype.onUpdate = function() {
  this.render();
  this.emitUpdate();
};

/**
 * Make updates to the field UI based upon its value
 */
SearchableOption.prototype.render = function() {
  if (!this.isEmpty()) {
    this.$selection.find('.js-searchable-option-field-selection-label')
      .html(this.getValueLabel());
  }
  this.$searcher.toggle(this.isEmpty());
  this.$selection.toggle(!this.isEmpty());
};

/**
 * Added a timeout to the focus because rendering the dropdown seems to be a bit slow
 * This allows any other action after calling this function to become unblocked
 */
SearchableOption.prototype.focus = function() {
  var self = this;
  setTimeout(function() {
    self.$input.focus();
  }, 0);
};

/**
 * Clear the fields value
 */
SearchableOption.prototype.clear = function() {
  this.value = undefined;
  this.indeterminate = false;
  this.$input.val('');
};

/**
 * Store the current value of the field
 */
SearchableOption.prototype.storeValue = function() {
  this.storedValue = {
    value: this.value,
    indeterminate: this.indeterminate,
  };
};

/**
 * Reset the field to its stored value
 */
SearchableOption.prototype.reset = function() {
  this.set(this.storedValue);
};

/**
 * Set the fields value and update the UI accordingly
 */
SearchableOption.prototype.set = function(field) {
  this.value = field.value;
  this.indeterminate = field.indeterminate;
  this.render();
};

/**
 * @return {boolean} True if the field is empty
 */
SearchableOption.prototype.isEmpty = function() {
  return !this.value;
};

/**
 * @return {boolean} True if the field is indeterminate
 */
SearchableOption.prototype.isIndeterminate = function() {
  return !!this.indeterminate;
};

/**
 * @return {string} The display value for this field
 */
SearchableOption.prototype.getDisplayValue = function() {
  if (this.isEmpty()) {
    return helpers.emptyFieldMessage();
  }
  return this.getValueLabel();
};

/**
 * Get the label for the fields current value
 */
SearchableOption.prototype.getValueLabel = function() {
  for (var i = 0; i < this.options.length; i++) {
    if (this.options[i].value === this.value) {
      return this.options[i].label;
    }
  }
};

/**
 * Get the fields current data as an object with string keys
 */
SearchableOption.prototype.getData = function() {
  return {
    'value': this.value,
  };
};

/**
 * Emit an update when the field's value changes
 */
SearchableOption.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

exports = SearchableOption;
